import { c as _c } from "react/compiler-runtime";
type Props = {
  children: React.ReactNode;
};
export function CardBody(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <dl className="divide-y divide-zinc-200 px-4 py-1 text-sm dark:divide-zinc-800 dark:text-zinc-400">{children}</dl>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}